<template>
  <div class="w-100 d-flex align-items-center" :class="[align]">
    <ButtonActions
      v-if="buttonText"
      :blank="buttonBlank"
      :path="buttonPath"
      :anchor-id-target="anchorIdTarget"
    >
      <template #action-scroll="{ item }">
        <Button
          :size="size"
          :to="item.path"
          :blank="item.blank"
          :extra-data="anchorIdTarget ? { event: '' } : {}"
          >{{ buttonText }}
        </Button>
      </template>
    </ButtonActions>
  </div>
</template>

<script>
import Button from 'UI/Button';
import ButtonActions from '@/components/Prismic/Landings/Utils/ButtonActions.vue';

export default {
  components: {
    Button,
    ButtonActions
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      buttonText: '',
      buttonBlank: false,
      buttonPath: '',
      size: '',
      anchorIdTarget: ''
    };
  },
  computed: {
    align() {
      const alignButton = this.slice.primary.align_button;
      let align = 'justify-content-start';
      if (alignButton == 'Center') {
        align = 'justify-content-center';
      } else if (alignButton == 'Right') {
        align = 'justify-content-right';
      }
      return align;
    },
    buttonHref() {
      return this.anchorIdTarget ? this.anchorIdTarget : this.buttonPath;
    }
  },
  created() {
    this.buttonText = this.slice.primary.button_text[0]?.text;
    this.buttonBlank = this.slice.primary.button_blank;
    this.buttonPath = this.slice.primary.button_path[0]?.text;
    this.size = this.slice.primary.size;
    this.anchorIdTarget = this.slice.primary.anchor_id_target;
  }
};
</script>

<style></style>
